export const isProductAvailable = {
  YES: "true",
  NO: "false",
}

export const isProductAdvertised = {
  YES: "true",
  NO: "false",
}
